import React from "react";

import BookmarkBalloonContainer from "containers/common/BookmarkBalloon";

const BookmarkBalloon = props => {
  return <BookmarkBalloonContainer {...props} />;
};

export default BookmarkBalloon;
